import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {
    deleteCustomTemplate,
    deleteTicket,
    editCustomTemplate,
    getCurrentChatLimit,
    getCustomTemplates,
    getDailyChatLimit,
    getOperatorCurrentStatusHistory,
    getOperatorHotkeysConfig,
    getOperatorTickets,
    updateTicketStatus
} from '../../../../services/company/api';
import {t} from '../../../../components/Translate';
import './MyHistory.css';
import config from "../../../../config";
import {
    clearSelectedConversation as clearSelectedConversationFromStore,
    loadOlderMessagesRequested,
    selectConversationRequested
} from "../../../../services/chat/action";
import {connect} from "react-redux";
import SelectedConversationHistory from "../management/history/ConversationHistory";
import LoadingComponent from "../../../../components-new/ui/LoadingComponent";
import StatisticsConvModal from "../../../../components-new/general/statistics/StatisticsConvModal";
import OperatorStatistics from "./components/OperatorStatistics";
import Tickets from "./components/Tickets";
import CustomTemplates from "./components/CustomTemplates";
import Hotkeys from "./components/Hotkeys";
import {getTodayDate, getTomorrowDate} from "../../../../utils/General";
import ConfirmationModal from "../../../../components-new/modals/ConfirmationModal";
import Colors from "../../../../utils/Colors";
import Tabs from "../../../../components-new/ui/Tabs";

const styles = {
    /*
     * Full width. maxWidth 95% with auto margins took another 2.5% off each
     * side on top of the page's own inset - on a wide screen a good deal more
     * than the inset itself, and it left the tabs above sitting further out
     * than the content under them.
     */
    container: {
        minHeight: '0',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '12px',
        justifyContent: 'space-between',
        overflowY: 'auto',
        padding: '4px 4px 0 4px',
        margin: '0 -4px',
    },
    dateFilterContainer: {
        display: 'flex',
        gap: '20px',
        justifyContent: 'center',
        marginBottom: '20px',
        alignItems: 'center',
    },
    card: {
        cursor: 'pointer',
        border: '1px solid var(--ds-border-secondary)',
        borderRadius: '10px',
        backgroundColor: 'var(--ds-bg-primary)',
        padding: '24px',
        flex: '1 1 calc(33.333% - 20px)',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center'
    },
    icon: {
        fontSize: '3rem',
        marginBottom: '10px',
        color: Colors.blueDark
    },
    searchInput: {
        width: '100%',
        marginBottom: '20px',
        boxSizing: 'border-box',
    },
    fullWidthContainer: {
        flex: '1 1 100%',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px'
    },
    /*
     * The page's own inset is the only one - see --ds-page-inset. This was a
     * white card with 40px of padding on a page that is now white too, so all
     * it did was hold the content a further 40px off the panel.
     */
    fullWidthCard: {
        flex: '1 1 100%',
        boxSizing: 'border-box',
        position: 'relative',
        maxHeight: '800px',
        overflow: 'auto'
    },
    parentTableDiv: {
        maxHeight: '295px',
        overflow: 'auto'
    },
    rowTicket: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap'
    },
    ticketColumn: {
        flex: '1 1 calc(33.333% - 20px)',
        margin: '10px',
        padding: '20px',
        borderRadius: '10px',
        position: 'relative',
        textAlign: 'center',
        minHeight: '400px'
    },
    /*
     * A border, not a 4px spread shadow - and the shadow it had could not have
     * rendered as written: rgba's first channel was -16, which is out of range
     * and makes the whole colour invalid.
     */
    ticketCard: {
        margin: '10px',
        padding: '16px',
        border: '1px solid var(--ds-border-secondary)',
        borderRadius: '10px',
        backgroundColor: 'var(--ds-bg-primary)',
        position: 'relative',
        textAlign: 'center',
        cursor: 'grab',
    },
    ticketTitle: {
        marginBottom: '10px',
        color: 'rgb(61, 86, 143)'
    },
    ticketCategory: {
        marginBottom: '10px'
    },
    btnTicket: {
        backgroundColor: Colors.blueDark,
        border: 'none',
        color: 'var(--ds-text-on-solid)',
        padding: '8px 15px',
        borderRadius: '15px',
        cursor: 'pointer'
    },
    pMarginBottom: {
        marginBottom: '15px',
    },
    closeBtn: {
        backgroundColor: 'var(--ds-bg-primary)',
        border: 'none',
        color: Colors.blueDark,
        padding: '15px',
        borderRadius: '15px',
        cursor: 'pointer',
    },
};

function MySpace({
                     user,
                     company,
                     selectConversation,
                     loadOlderMessages,
                     clearSelectedConversationFromStore,
                     conversation,
                     addNotification
                 }) {

    const {tariff} = company;
    const {features} = tariff;

    const [tickets, setTickets] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupContent, setPopupContent] = useState({});
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
    const [ticketToDelete, setTicketToDelete] = useState(null);
    const [columnToDeleteFrom, setColumnToDeleteFrom] = useState(null);
    const [ticketColumns, setTicketColumns] = useState({
        'toDo': [],
        'inProgress': [],
        'done': []
    });
    const [fetched, setFetched] = useState(false);

    const [customTemplates, setCustomTemplates] = useState([]);
    const [hotkeys, setHotkeys] = useState([]);

    const [currentStatusHistory, setCurrentStatusHistory] = useState([]);

    const [dailyChatsLimit, setDailyChatsLimit] = useState('');
    const [currentChatsLimit, setCurrentChatsLimit] = useState('');
    const [avrgConvTime, setAvrgConvTime] = useState('');
    const [avrgAnswerSpeed, setAvrgAnswerSpeed] = useState('');
    const [avrgFirstAnswerSpeed, setAvrgFirstAnswerSpeed] = useState('');

    const [activeTab, setActiveTab] = useState('statistics');

    const [startDateForCurrentStatus, setStartDateForCurrentStatus] = useState(getTodayDate());
    const [endDateForCurrentStatus, setEndDateForCurrentStatus] = useState(getTomorrowDate());

    const [propKey, setPropKey] = useState();
    const [propFilters, setPropFilters] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        getOperatorCurrentStatusHistory(startDateForCurrentStatus, endDateForCurrentStatus).then(data => {
            setCurrentStatusHistory(data);
        })
    }, [startDateForCurrentStatus, endDateForCurrentStatus])

    useEffect(() => {
        const fetchChatCount = async () => {
            try {
                const promises = [];
                const resultsMapping = {};

                if (features.includes(config.features.MY_HISTORY)) {
                    resultsMapping[config.features.MY_HISTORY] = promises.length;
                    promises.push(
                        Promise.all([
                            getDailyChatLimit(),
                            getCurrentChatLimit(),
                            getOperatorCurrentStatusHistory(startDateForCurrentStatus, endDateForCurrentStatus)
                        ])
                    );
                }

                if (features.includes(config.features.TEMPLATES)) {
                    resultsMapping[config.features.TEMPLATES] = promises.length;
                    promises.push(getCustomTemplates());
                }

                if (features.includes(config.features.TICKETS)) {
                    resultsMapping[config.features.TICKETS] = promises.length;
                    promises.push(getOperatorTickets());
                }

                if (features.includes(config.features.HOTKEYS)) {
                    resultsMapping[config.features.HOTKEYS] = promises.length;
                    promises.push(getOperatorHotkeysConfig());
                }


                const results = await Promise.all(promises);

                if (config.features.MY_HISTORY in resultsMapping) {
                    const [
                        dailyChatsLimit,
                        currentChatsLimit,
                        currentStatusHistory
                    ] = results[resultsMapping[config.features.MY_HISTORY]];

                    setDailyChatsLimit(dailyChatsLimit);
                    setCurrentChatsLimit(currentChatsLimit);
                    setAvrgConvTime(avrgConvTime);
                    setAvrgAnswerSpeed(avrgAnswerSpeed);
                    setAvrgFirstAnswerSpeed(avrgFirstAnswerSpeed);
                    setCurrentStatusHistory(currentStatusHistory);
                }

                if (config.features.TICKETS in resultsMapping) {
                    const tickets = results[resultsMapping[config.features.TICKETS]];
                    setTickets(tickets);
                    setTicketColumns({
                        toDo: tickets.filter(ticket => ticket.ticketStatus === "TODO"),
                        inProgress: tickets.filter(ticket => ticket.ticketStatus === "IN_PROGRESS"),
                        done: tickets.filter(ticket => ticket.ticketStatus === "DONE"),
                    });
                }

                if (config.features.TEMPLATES in resultsMapping) {
                    const customTemplates = results[resultsMapping[config.features.TEMPLATES]];
                    setCustomTemplates(customTemplates);
                }

                if (config.features.HOTKEYS in resultsMapping) {
                    const hotkeysData = results[resultsMapping[config.features.HOTKEYS]];
                    setHotkeys(hotkeysData);
                }

                setFetched(true);
            } catch (error) {
                setFetched(false);
                console.error("Error fetching chat counts:", error);
            }
        };

        fetchChatCount();
    }, [user.id, features]);


    const onDragStart = (event, ticketId, column) => {
        event.dataTransfer.setData('ticketId', ticketId);
        event.dataTransfer.setData('fromColumn', column);

    };

    const onDrop = (event, column) => {
        const ticketId = event.dataTransfer.getData('ticketId');
        const fromColumn = event.dataTransfer.getData('fromColumn');

        if (fromColumn !== column) {
            setTicketColumns((prev) => {
                const fromTickets = prev[fromColumn].filter((ticket) => ticket.id !== parseInt(ticketId));
                const ticketToMove = prev[fromColumn].find((ticket) => ticket.id === parseInt(ticketId));
                const toTickets = [...prev[column], ticketToMove];
                return {
                    ...prev,
                    [fromColumn]: fromTickets,
                    [column]: toTickets
                };
            });
        }

        let columnName;
        if (column === 'toDo') {
            columnName = "TODO"
        } else if (column === "inProgress") {
            columnName = "IN_PROGRESS"
        } else if (column === "done") {
            columnName = "DONE"
        }
        updateTicketStatus(ticketId, columnName)
    };

    const allowDrop = (event) => {
        event.preventDefault();
    };

    const openPopup = (ticket) => {
        setPopupContent(ticket);
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setPopupContent({});
    };

    const handleDeleteTicket = (ticketId, column) => {
        setTicketToDelete(ticketId);
        setColumnToDeleteFrom(column);
        setShowConfirmationDialog(true);
    };

    const confirmDelete = () => {
        setTicketColumns((prev) => {
            const updatedColumn = prev[columnToDeleteFrom].filter((ticket) => ticket.id !== ticketToDelete);
            return {
                ...prev,
                [columnToDeleteFrom]: updatedColumn
            };
        });
        setShowConfirmationDialog(false);
        deleteTicket(ticketToDelete);
        addNotification('deleted', config.notificationLevels.info)
    };

    const cancelDelete = () => {
        setShowConfirmationDialog(false);
        setTicketToDelete(null);
        setColumnToDeleteFrom(null);
    };

    const showConversationHistory = (conversationDetails) => {
        selectConversation({
            id: conversationDetails.conversationId,
            companyId: conversationDetails.companyId,
            platform: conversationDetails.platform,
            userFirstName: conversationDetails.customerName,
            userThumbUrl: conversationDetails.visitorThumbUrl,
            isOperatorConversation: true,
            operatorConversationId: conversationDetails.id
        });
    };

    const showFullConversationHistory = (conversationDetails) => {
        selectConversation({
            id: conversationDetails.conversationId,
            companyId: conversationDetails.companyId,
            platform: conversationDetails.platform,
            userFirstName: conversationDetails.customerName,
            userThumbUrl: conversationDetails.visitorThumbUrl,
        });
    };

    const openTrModal = (key, filters = {}) => {
        setPropFilters(filters);
        setPropKey(key);
        setIsModalOpen(true);
    };

    const updatePopupContent = (content) => {
        const updatedColumns = Object.keys(ticketColumns).reduce((acc, columnKey) => {
            const updatedColumn = ticketColumns[columnKey].map(ticket =>
                ticket.id === content.id ? {...ticket, ...content} : ticket
            );
            return {...acc, [columnKey]: updatedColumn};
        }, {});
        setTicketColumns(updatedColumns);
    }

    const editCustomTemplateF = (id, text) => {
        editCustomTemplate(id, text)
    }

    const deleteCustomTemplateF = (customTemplateId) => {
        deleteCustomTemplate(customTemplateId);
        setCustomTemplates(prevTemplates =>
            prevTemplates.filter(template => template.id !== customTemplateId)
        );
    }

    if (!fetched) {
        return <LoadingComponent containerStyles={{transform: 'translate(-33px, -33px)'}}/>;
    }

    return (
        <div
            className={`fade-in ${activeTab === 'hotkeys' ? 'my-space--hotkeys' : ''}`}
            style={{display: 'flex', flexDirection: 'column', gap: '16px', height: '100%'}}
        >
            <div>
                <Tabs
                    selectedTab={activeTab}
                    onTabChange={setActiveTab}
                    tabs={[
                        ...(features.includes(config.features.MY_HISTORY) ? ['statistics'] : []),
                        ...(features.includes(config.features.TEMPLATES) ? ['templates'] : []),
                        ...(features.includes(config.features.TICKETS) ? ['tickets'] : []),
                        ...(features.includes(config.features.HOTKEYS) ? ['hotkeys'] : [])
                    ]}
                />
            </div>

            <div style={styles.container} className={activeTab === 'hotkeys' ? 'my-space__hotkeys-content' : undefined}>
                {features.includes(config.features.MY_HISTORY) && activeTab === 'statistics' && company && user && (
                    <OperatorStatistics
                        company={company}
                        user={user}
                        currentStatusStartDate={startDateForCurrentStatus}
                        currentStatusEndDate={endDateForCurrentStatus}
                        setCurrentStatusStartDate={setStartDateForCurrentStatus}
                        setCurrentStatusEndDate={setEndDateForCurrentStatus}
                        dailyChatsLimit={dailyChatsLimit} currentChatsLimit={currentChatsLimit}
                        currentStatusHistory={currentStatusHistory}
                        openTrModal={openTrModal}
                    />
                )}

                {features.includes(config.features.TEMPLATES) && activeTab === 'templates' && (
                    <CustomTemplates
                        styles={styles}
                        user={user}
                        customTemplates={customTemplates}
                        deleteCustomTemplate={deleteCustomTemplateF}
                        editCustomTemplate={editCustomTemplateF}
                        setCustomTemplates={setCustomTemplates}
                        addNotification={addNotification}
                    />
                )}


                {features.includes(config.features.TICKETS) && activeTab === 'tickets' && (
                    <Tickets user={user} company={company} styles={styles} allowDrop={allowDrop} onDrop={onDrop}
                             ticketColumns={ticketColumns} onDragStart={onDragStart} openPopup={openPopup}
                             handleDeleteTicket={handleDeleteTicket} updatePopupContent={updatePopupContent}
                             showConversationHistory={showConversationHistory} isPopupOpen={isPopupOpen}
                             closePopup={closePopup} popupContent={popupContent} addNotification={addNotification}/>
                )}

                {features.includes(config.features.HOTKEYS) && activeTab === 'hotkeys' && (
                    <Hotkeys
                        styles={styles}
                        user={user}
                        hotkeys={hotkeys}
                        setHotkeys={setHotkeys}
                        addNotification={addNotification}
                    />
                )}

                <ConfirmationModal
                    variant="delete"
                    isOpen={showConfirmationDialog}
                    onClose={cancelDelete}
                    onConfirm={confirmDelete}
                    message={t({text: "deleteTicketFinalText", user})}
                />

                {!!conversation.id &&
                    <SelectedConversationHistory
                        isOpen={!!conversation.id}
                        company={company}
                        conversation={conversation}
                        user={user}
                        loadOlderMessages={loadOlderMessages}
                        closeWindow={clearSelectedConversationFromStore}
                    />
                }

                {/*important case*/}
                {isModalOpen &&
                    <StatisticsConvModal
                        isOpen={isModalOpen}
                        cancelAction={() => setIsModalOpen(false)}
                        user={user}
                        company={company}
                        showConversationHistory={showConversationHistory}
                        showFullConversationHistory={showFullConversationHistory}
                        header={propKey}
                        filters={{
                            ...propFilters,
                            operatorId: user.postgresId,
                            operator: user.firstName + ' ' + user.lastName
                        }}
                    />
                }


            </div>

        </div>
    );
}

MySpace.propTypes = {
    match: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    addNotification: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    conversation: state.chat.conversation,
});

const mapDispatchToProps = (dispatch) => ({
    selectConversation: (conversation) => {
        dispatch(selectConversationRequested(conversation));
    },
    loadOlderMessages: () => {
        dispatch(loadOlderMessagesRequested());
    },
    clearSelectedConversationFromStore: () => {
        dispatch(clearSelectedConversationFromStore());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(MySpace);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/my-history/MySpace.jsx